namespace $.$$ {
	$mol_style_define( $shm_showcase_info, {
		flex: { basis: $mol_style_unit.rem( 24 ), grow: 0, shrink: 0 },
	} )
}
